import React from "react";
import { BrowserRouter } from "react-router-dom";
import { observer, Provider } from "mobx-react";
import Routes from "./components/routes/routes";
import AppStore from "./stores";

const store = new AppStore();

const App: React.FC = () => (
  <Provider store={store}>
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  </Provider>
);

export default observer(App);
